module.exports = __webpack_public_path__ + "img/default-identity-back-img.49a677f1.png";